export const TEST_ID = 'customerIcon';
